import { registerComponent, triggerEvent } from "helpers";
import WYATTDialog from "wyatt-dialog";

registerComponent(
  "wyatt-drawer",
  class WyattDrawer extends WYATTDialog {
    open() {
      super.open();

      triggerEvent(this.dialog, "drawerOpen");
    }

    close() {
      super.close();

      triggerEvent(this.dialog, "drawerClose");
    }
  },
);
